import React from 'react';
import AnimatedSection from './AnimatedSection';
import SectionHeading from './SectionHeading';
import { ChevronRight } from 'lucide-react';

const skills = [
  "Kubernetes platform engineering",
  "Multi-cloud and on-prem infrastructure",
  "GPU orchestration for LLM workloads",
  "AI agents with LangGraph and Azure OpenAI",
  "Infrastructure as Code with Terraform",
  "Reliability, observability, and SLOs"
];

export default function About() {
  return (
    <AnimatedSection id="about">
      <SectionHeading number={1}>About Me</SectionHeading>
      <div className="grid md:grid-cols-5 gap-12">
        {/* Text Section */}
        <div className="md:col-span-3 text-slate-400 space-y-5 text-base leading-relaxed">
          <p>
            I am a Platform Engineer focused on the infrastructure beneath modern intelligence: Kubernetes platforms, distributed systems, GPU orchestration, and AI-powered engineering tools.
          </p>
          <p>
            At Johnson Controls, I have designed resilient platforms across AWS, Azure, GCP, and on-prem environments. I care about the details that make a platform disappear for its users: fast delivery paths, clear failure modes, useful observability, and an excellent developer experience.
          </p>
          <p>
            Some of the technologies and frameworks I actively work with include:
          </p>
          <ul className="grid grid-cols-2 gap-y-2 gap-x-10 font-mono text-base mt-2">
            {skills.map(skill => (
              <li key={skill} className="flex items-center text-slate-300">
                <ChevronRight className="text-teal-300 w-5 h-5 mr-2" />
                {skill}
              </li>
            ))}
          </ul>
        </div>
        {/* Image Section */}
        <div className="md:col-span-2 relative group mt-4 md:mt-0">
          {/* Teal shadow box */}
          <div className="w-full h-full rounded-lg bg-teal-300/90 absolute top-7 left-7 z-0 group-hover:translate-x-2 group-hover:translate-y-2 transition duration-300"></div>
          {/* Main image */}
          <div
            className="w-full h-80 rounded-lg overflow-hidden bg-cover bg-center bg-no-repeat relative z-10 shadow-lg"
            style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1587620962725-abab7fe55159?q=80&w=1931&auto=format&fit=crop)',
              filter: 'grayscale(100%) contrast(1.2)'
            }}
          >
            <div className="w-full h-full bg-slate-900/60 hover:bg-transparent transition-all duration-300 rounded-lg"></div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
}
